import * as ko from "knockout";
import {IExpressionParams} from "./builder";
import expressionHtml from './expression.html?raw';

export let template = expressionHtml;

export class viewModel {
    private initialExpression: string;

    constructor(private params: IExpressionParams) {
        this.initialExpression = params.expression();
    }

    private onRestoreClick() {
        this.params.expression(this.initialExpression);
    }

    isChanged = ko.pureComputed(() => this.params.expression() != this.initialExpression);

    private onSaveClick() {
        this.params.save?.(this.params.expression())
    }

    private onCancelClick() {
        this.params.cancel()
    }
}
